module.exports = __webpack_public_path__ + "img/f1-2-icon2.b447dfdc.png";